import { http } from '../../services/http'
const state = {
  orders: {
    current_page: null,
    from: null,
    last_page: null,
    offset: null,
    per_page: null,
    to: null,
    total: null,
    data: []
  },
  status: []
}

const getters = {
  supplyOrders(state) {
    return state.orders.data
  },
  supplyOrdersSelected(state) {
    state.orders.data.some(item => {
      return item.selected
    })
  }
}

const actions = {
  getSupplyOrders(context) {
    http()
      .get('supply-orders')
      .then(res => {
        context.commit('updateSupplyOrders', res.data)
      })
  },

  getSupplyOrdersStatus(context) {
    http()
      .get('supply-orders-status')
      .then(res => {
        context.commit('updateSupplyOrderStatus', res.data)
      })
  }
}

const mutations = {
  updateSupplyOrders(state, payload) {
    payload.data.map(item => Object.assign(item, { selected: false }))
    state.orders = payload
  },
  updateSupplyOrderStatus(state, payload) {
    state.status = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/supplyOrders.js